import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_DASHBOARD_PATIENT_LIST_FAILURE,
  GET_DASHBOARD_PATIENT_LIST_LOADER,
  GET_DASHBOARD_PATIENT_LIST_SUCCESS,
  GET_DASHBOARD_PATIENT_LIST_REQUEST,
} = DashboardConstants;

function* dashboardPatientList(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_PATIENT_LIST_LOADER });
    const response = yield call(dashboardServices.getDashboardPatientList, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_PATIENT_LIST_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_PATIENT_LIST_FAILURE, payload: error });
  }
}

function* dashboardPatientListSaga() {
  yield takeEvery(GET_DASHBOARD_PATIENT_LIST_REQUEST, dashboardPatientList);
}

export default dashboardPatientListSaga;
